import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {HeroHeading2} from "../text";
import {reset, selectError} from "../../redux/auth/authSlice";
import {selectError as selectSurveyError, reset as resetSurvey} from "../../redux/survey/macroSurveySlice";
import {BaseError} from "../../errors/baseError";
import {AuthValidationError} from "../../errors/authValidationError";
import {AlertDialog} from "../dialogs/AlertDialog";
import {LoginFormView} from "../login/LoginFormView";
import {LoginViewConfig} from "../login/LoginView";
import {EventLogger} from "../../utils/eventLogger";
import {AnalyticsEvent} from "../../utils/eventProperties";

export const MacroSurveyLoginView: React.FC<any> = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [selectedConfig, setSelectedConfig] = useState<LoginViewConfig>('get_macro_plan')

  const error = useAppSelector(selectError)
  const surveyError = useAppSelector(selectSurveyError)
  const [authError, setAuthError] = useState<BaseError<any> | null>()

  useEffect(() => {
    EventLogger.logEvent(new AnalyticsEvent({ eventName: 'Screen Visited', screenName: 'Nutrition Survey' }, { 'Survey Question': 'Login' }))
  }, [])

  useEffect(() => {
    setAuthError(!(error instanceof AuthValidationError) ? error ?? surveyError : null)
  },  [error, surveyError])

  useEffect(() => {
    dispatch(reset())
    dispatch(resetSurvey())
  }, [dispatch])

  let title: string;
  switch (selectedConfig) {
    case "sign_up":
      title = t('macro_survey:macro_survey_header_title_create_account')
      break;
    case "post_purchase":
      title = t('auth:auth_title_order_received_create_account')
      break;
    case "get_started":
      title = t('macro_survey:macro_survey_header_title_create_account')
      break;
    case "get_macro_plan":
      title = t('macro_survey:macro_survey_header_title_create_account')
      break;
    case "sign_in":
      title = t('macro_survey:macro_survey_header_title_login')
      break;
    case "forgot_password":
      title = t('auth:auth_title_forgot_password')
      break;
  }

  return <div className="md:max-w-lg md:rounded-xl md:border-2 md:border-fg-gray-surface md:py-8 mx-auto mt-10">
    <AlertDialog
      isOpen={!!authError}
      error={authError}
      onClose={() => {
        dispatch(reset())
        dispatch(resetSurvey())
      }}
      buttons={[
        {
          title: { key: 'common:common_title_ok' },
          onClick: () => {},
          style: 'default'
        }
      ]}
    />
    <div className="flex flex-col space-y-8 lg:space-y-10 items-center w-full px-6">
      <div className="w-full space-y-8 lg:space-y-10">
        <HeroHeading2 className="text-center mx-8">{title}</HeroHeading2>

        <LoginFormView config={'get_macro_plan'} onSelectedConfigChange={setSelectedConfig} />
      </div>
    </div>
  </div>
}